"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhoneSolidIcon = void 0;
var React = _interopRequireWildcard(require("react"));
var _SvgIcon = require("../SvgIcon");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
} /**
  * This file was generated by the build:icons script
  * See Notion for details on how to add icons
  */
const PhoneSolidIcon = props => /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, _extends({}, props, {
  viewBox: "0 0 24 24"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m5.704 4.001 2.524.01c.785.002 1.352.644 1.577 1.314.111.33.277.855.417 1.367.125.462.274 1.067.276 1.475v.054c.003.278.006.691-.258 1.132a3.14 3.14 0 0 1-.406.518c-.12.13-.271.282-.449.46.04.157.145.399.338.713.397.645 1.005 1.343 1.448 1.787.51.508 1.195 1.12 1.815 1.505.3.186.521.278.658.309.31-.31.63-.627.94-.836.41-.274.944-.462 1.567-.252.256.086.709.19 1.224.307l.08.019c.438.099.95.215 1.245.322.608.22 1.289.745 1.292 1.57l.01 2.524c.002.579-.26 1.039-.652 1.32a1.7 1.7 0 0 1-.94.312c-1.863.107-6.166-.685-9.91-4.429-2.34-2.34-3.459-4.623-3.983-6.438-.475-1.641-.454-2.879-.447-3.32l.001-.11c-.002-.58.26-1.04.652-1.32A1.7 1.7 0 0 1 5.703 4Z"
}));
exports.PhoneSolidIcon = PhoneSolidIcon;